import React from "react";
import { Link } from 'react-router-dom'
import "../App.css";
import CommentForm from "./CommentForm.jsx";
import helpIcon from "../assets/delete.png";
import likeIcon from "../assets/thumbsup.png";
import "./Post.css"
import commentIcon from "../Component/images/comment.png"
import thumbsupIcon from "../Component/images/like.png"
import shareIcon from "../Component/images/share.png"
import reportIcon from "../Component/images/report.png"

/* This will render a single post, with all of the options like comments, delete, tags, etc.  In the harness, it's only called from PostingList, but you could
  also have it appear in a popup where they edit a post, etc. */
export default class Contribution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: this.props.post,
      addInc: this.props.post.value,
      voting: true,
      title:"",
      content:""
    };
  }

  showTags = e => {
    this.setState({
      showTags: !this.state.showTags
    });
  };

  // this is the simplest version of reactions; it's only mananging one reaction, liking a post.  If you unlike the post, 
  // it deletes the reaction.  If you like it, it posts the reaction.  This will almost certainly be made more complex
  // by you, where you will account for multiple different reactions.  Note that in both cases, we reload the post afterwards to
  // show the updated reactions.
  loadVoting(){
    fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.props.post.id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
    }) .then(res => res.json())
    .then(
      result => {
        if (result) {
          console.log("res",result)
          if(result.attributes.reactions.length>0&&result.attributes.reactions.includes(sessionStorage.getItem("user"))){
            this.setState({
              voting: false
            })
          }
        }
      }
    )
  }
  componentDidMount(){
    this.loadVoting();
  }
  tagPost(tag, thisPostID){
    this.setState({
      title: this.props.post.attributes.title,
      content: this.props.post.attributes.content
    })
    console.log("attributes",this.props.post.attributes)
     if (this.props.post.attributes.reactions.length>0&&this.props.post.attributes.reactions.includes(sessionStorage.getItem("user"))){
      //make the api call to post
      var newReactions = this.props.post.attributes.reactions;
      newReactions.pop(sessionStorage.getItem("user"));
      fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.props.post.id, {
        method: "PATCH",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+sessionStorage.getItem("token")
        },
        body:JSON.stringify({
          attributes:{
            title: this.state.post.attributes.title,
            content: this.state.post.attributes.content,
            reactions: newReactions
          }
        })
      });
     }else{
     //make the api call to post
     var newReactions = this.props.post.attributes.reactions;
     newReactions.push(sessionStorage.getItem("user"));
     fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.props.post.id, {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        attributes:{
        title: this.state.post.attributes.title,
            content: this.state.post.attributes.content,
            reactions: newReactions
        }
      })
      });
     }
  }


  deletePost(postID) {
    //make the api call to post
    fetch(process.env.REACT_APP_API_PATH+"/posts/"+postID, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
      })
      .then(
        result => {
          this.props.loadPosts();
        },
        error => {
          console.log("error!" + error);
        }
      );
  }

  // we only want to expose the delete post functionality if the user is
  // author of the post
  showDelete(){
    if (this.props.post.reactor.id === sessionStorage.getItem("user")) {
      return(
      <img
        src={helpIcon}
        className="deleteIcon"
        alt="Delete Post"
        title="Delete Post"
        onClick={e => this.deletePost(this.props.post.id)}
      />
    );
    }
    return "";
  }
 increment= event =>{
   console.log("THIS.PROPS", this.props.post)
  fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.props.post.id, {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+sessionStorage.getItem("token")
    },
    body: JSON.stringify({
      value: this.state.addInc+1
    })
  }).then(
    this.setState({
      addInc: this.state.addInc+1,
      voting: !this.state.voting
    }),
    this.tagPost("vote",this.props.post.id)
  );
  
 }
 decrement= event =>{
  console.log("THIS.PROPS", this.props.post)
 fetch(process.env.REACT_APP_API_PATH+"/post-reactions/"+this.props.post.id, {
   method: "PATCH",
   headers: {
     'Content-Type': 'application/json',
     'Authorization': 'Bearer '+sessionStorage.getItem("token")
   },
   body: JSON.stringify({
     value: this.state.addInc-1
   })
 }).then(
   this.setState({
     addInc: this.state.addInc-1,
     voting: !this.state.voting
   }),
   this.tagPost("vote",this.props.post.id)
 );
}
  render() {
    return (
      <div className="contribution">
        <div key={this.state.post.id} className="postbody">
            <div className="postHeader">
                <div className="contributionPfp">
                  <img className="postpfp" src={this.state.post.reactor.attributes.pfp} alt={this.props.post.reactor.username}></img>
                    <Link to={"/user/"+this.state.post.reactor.id} className="postName">
                      {this.state.post.reactor.attributes.username}
                    </Link>
                </div>
                <div className="upvote">{this.state.addInc} Upvotes</div>

            {this.showDelete()}
        </div>
        
      <div className="postTitle">{this.state.post.attributes.title}</div>
      <div className="postText">{this.state.post.attributes.content}</div>
      
      <div className="postBot">
        
        {this.state.voting ? <button className="voting" onClick={this.increment.bind(this)}>Vote</button>:<button className="voting" onClick={this.decrement.bind(this)}>Downvote</button>}
        <img className="postReport" alt="report symbol" src={reportIcon}></img>
        <div className="reporttext">Report</div>
      </div>

      </div>
      </div>
    );
  }
}
